import React, { useCallback, useState } from 'react';
import { Typography } from 'src/ui/common/atoms/typography';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { StyledFilterContent, StyledFilterHeader } from './styles';

export const FilterItem: React.FC<{ title: string, isActive?: boolean, openedByDefault?: boolean }> = ({
    isActive, openedByDefault, title, children
}) => {
    const [opened, setOpened] = useState(!!openedByDefault);

    const toggle = useCallback(() => setOpened(s => !s), []);

    return (
        <div>
            <StyledFilterHeader
                alignItems='center'
                justifyContent='space-between'
                onClick={toggle}
                isActive={!!isActive}
            >
                <Typography size='sm' medium>
                    {title}
                </Typography>
                <SvgIcon width={16} height={16} variant='regular' icon={opened ? 'chevronUp' : 'chevronDown'} />
            </StyledFilterHeader>
            <StyledFilterContent opened={opened}>
                <div>{children}</div>
            </StyledFilterContent>
        </div>
    );
};
